module.exports = __webpack_public_path__ + "img/03_team_photo_2026.20112b7a.jpg";